import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import Cookies from 'js-cookie';

import { getAuthState, getClientCredentialsToken } from '../../store/AuthSlice';
import { useAppSelector } from '../../hooks';
import FullScreenLoader from '../../components/Loaders/FullScreenloader';
import AdminDashboard from '../AdminPages/AdminDashboard';
import UserDashboard from '../UserPages/UserDashboard';
import InvalidAuthentication from '../Validate/InvalidAuthentication';

const Dashboard: React.FC = () => {
  const dispatch = useDispatch();

  // Store
  const authState = useAppSelector(getAuthState);

  const authUser = authState.user;
  const CookieUser = Cookies.get('tutopiya_user_id');

  useEffect(() => {
    if (
      CookieUser &&
      (!authState.accessToken || authUser?.role.name === 'Guest')
    ) {
      dispatch(
        getClientCredentialsToken({
          auth_type: 'cookie',
          user_id: CookieUser,
        })
      );
    } else if (!authState.accessToken) {
      dispatch(
        getClientCredentialsToken({
          auth_type: 'guest',
        })
      );
    }
  }, []);

  const RENDER_CONTENTS = () => {
    if (authState.status === 'loading' || !authState.accessToken) {
      return <FullScreenLoader />;
    }

    if (authState.status === 'rejected') {
      window.location.href = `${process.env.PUBLIC_URL}/`;
    } else if (authState.accessToken && authUser) {
      if (authUser.role?.type === 'admin') {
        return <AdminDashboard />;
      }

      if (authUser.role?.type === 'user') {
        return <UserDashboard />;
      }

      return <InvalidAuthentication />;
    }

    return null;
  };

  return <div>{RENDER_CONTENTS()}</div>;
};

export default Dashboard;
